export async function optimizeImage(file: File, maxSize = 900): Promise<string> {
  if (file.type === 'image/svg+xml') return fileToDataUrl(file)
  const objectUrl = URL.createObjectURL(file)
  const source = await new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image()
    image.onload = () => resolve(image)
    image.onerror = reject
    image.src = objectUrl
  })
  try {
    const ratio = Math.min(1, maxSize / Math.max(source.width, source.height))
    const canvas = document.createElement('canvas')
    canvas.width = Math.max(1, Math.round(source.width * ratio))
    canvas.height = Math.max(1, Math.round(source.height * ratio))
    const context = canvas.getContext('2d')
    if (!context) throw new Error('Canvas недоступен')
    context.drawImage(source, 0, 0, canvas.width, canvas.height)
    return canvas.toDataURL('image/webp', .86)
  } finally { URL.revokeObjectURL(objectUrl) }
}

export function fileToDataUrl(file:File):Promise<string>{return new Promise((resolve,reject)=>{const reader=new FileReader();reader.onload=()=>resolve(String(reader.result));reader.onerror=()=>reject(reader.error);reader.readAsDataURL(file)})}
